import { IntegrationScope } from 'src/api';
import { INTEGRATION_SCOPE_LABELS } from 'src/constants/integration';

export const SCOPE_OPTIONS: ReadonlyArray<{
  value: IntegrationScope;
  title: string;
  description: string;
}> = [
  {
    value: IntegrationScope.Employment,
    title: INTEGRATION_SCOPE_LABELS[IntegrationScope.Employment],
    description: 'Verifications of Employment (VOE)',
  },
  {
    value: IntegrationScope.Income,
    title: INTEGRATION_SCOPE_LABELS[IntegrationScope.Income],
    description: 'Verifications of Income (VOI)',
  },
  {
    value: IntegrationScope.Government,
    title: INTEGRATION_SCOPE_LABELS[IntegrationScope.Government],
    description: 'SSA, IRS, and other government data sources',
  },
  {
    value: IntegrationScope.BatchUpload,
    title: INTEGRATION_SCOPE_LABELS[IntegrationScope.BatchUpload],
    description:
      'Access to batch endpoints — submit verifications as JSON arrays or via file upload',
  },
];
